import { render, staticRenderFns } from "./StatisticsMarket.vue?vue&type=template&id=a6da20c0&scoped=true&"
import script from "./StatisticsMarket.vue?vue&type=script&lang=js&"
export * from "./StatisticsMarket.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMarket.vue?vue&type=style&index=0&id=a6da20c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6da20c0",
  null
  
)

export default component.exports